// Utilitário: extrai todos os arquivos de áudio/vídeo a partir de items
// arrastados (suportando múltiplas pastas com subpastas) usando webkitGetAsEntry.

const MEDIA_EXTS = new Set([
  "mp3", "m4a", "wav", "ogg", "aac", "flac",
  "mp4", "mov", "webm", "mkv", "avi", "m4v",
]);

const isMediaFile = (f) => {
  if (!f) return false;
  const t = (f.type || "").toLowerCase();
  if (t.startsWith("audio/") || t.startsWith("video/")) return true;
  const ext = (f.name.split(".").pop() || "").toLowerCase();
  return MEDIA_EXTS.has(ext);
};

const readEntries = (reader) =>
  new Promise((resolve, reject) => reader.readEntries(resolve, reject));

const getFile = (fileEntry) =>
  new Promise((resolve, reject) => fileEntry.file(resolve, reject));

async function walkEntry(entry, relPath = "") {
  if (!entry) return [];
  const out = [];
  if (entry.isFile) {
    try {
      const file = await getFile(entry);
      if (isMediaFile(file)) {
        // grava o caminho relativo para inspeção (não obrigatório)
        try {
          Object.defineProperty(file, "webkitRelativePath", {
            value: relPath ? `${relPath}/${file.name}` : file.name,
            writable: false,
          });
        } catch (_) {}
        out.push(file);
      }
    } catch (_) {}
    return out;
  }
  if (entry.isDirectory) {
    const reader = entry.createReader();
    // readEntries devolve em lotes; precisamos chamar até retornar 0
    let batch;
    do {
      batch = await readEntries(reader);
      for (const child of batch) {
        const sub = await walkEntry(child, relPath ? `${relPath}/${entry.name}` : entry.name);
        out.push(...sub);
      }
    } while (batch.length > 0);
  }
  return out;
}

export async function extractFilesFromDataTransfer(dt) {
  const items = dt.items;
  const collected = [];
  if (items && items.length) {
    const entries = [];
    for (let i = 0; i < items.length; i++) {
      const it = items[i];
      const entry = it.webkitGetAsEntry ? it.webkitGetAsEntry() : null;
      if (entry) entries.push(entry);
      else {
        const f = it.getAsFile && it.getAsFile();
        if (f && isMediaFile(f)) collected.push(f);
      }
    }
    for (const entry of entries) {
      const sub = await walkEntry(entry);
      collected.push(...sub);
    }
  } else if (dt.files) {
    for (const f of dt.files) if (isMediaFile(f)) collected.push(f);
  }
  return collected;
}

export { isMediaFile };
